import { Component, OnDestroy } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { AccountUserService } from '../service/account.service';
import { MessageService } from 'primeng/api';
import { Subject, takeUntil } from 'rxjs';
@Component({
  selector: 'app-forgot-organization-id',
  templateUrl: './forgot-organization-id.component.html',
  styleUrl: './forgot-organization-id.component.scss'
})
  export class ForgotOrganizationIDComponent implements OnDestroy {
    email = new FormControl('', [Validators.required, Validators.email]);
    submitted = false;
    assestBaseUrl: string = environment.assestsBasePath;
    private ngUnsubscribe = new Subject<void>();

    constructor(
      private accountSevice: AccountUserService,
      private messageService: MessageService,
    ) { }

    onSubmit(): void {
      this.submitted = true;
      if (this.email.valid) {
        console.log('Reset Password Request:', this.email.value);
        const data :any = {
          emailId: this.email?.value
        }
        // Implement API call to handle password reset request
        this.accountSevice.recoverOrgLoginDetails(data).pipe(takeUntil(this.ngUnsubscribe)).subscribe({
          next: (response) => {;
            if(response?.isSuccess){
            this.messageService.add({ severity: 'success', summary: 'Success', detail: response?.message ? response?.message : 'Organization ID sent to your email address' });
            }
          },
          error: (error) => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Invalid Email. Please verify your details and try again.'});
          },
          complete: () => {
          }
        });
      }
    }

    ngOnDestroy() {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }
  }
 